import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { TheProblem } from './components/TheProblem';
import { FailedApproaches } from './components/FailedApproaches';
import { UniqueMechanism } from './components/UniqueMechanism';
import { Deliverables } from './components/Deliverables';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans selection:bg-brand-gold selection:text-brand-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <TheProblem data-id="element-3" />
      <FailedApproaches data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <Deliverables data-id="element-6" />
      <WhoIsItFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <Offer data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}